(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const unlockInstafeedSwipe = () => {
    document
      .querySelectorAll('#insta-feed [data-instafeed-prevent-touch-scroll]')
      .forEach((element) => element.removeAttribute('data-instafeed-prevent-touch-scroll'));
  };

  const enableDragSwipe = (wrapper) => {
    if (wrapper.dataset.swipeReady === 'true') return;

    wrapper.dataset.swipeReady = 'true';

    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let isHorizontalSwipe = false;

    wrapper.addEventListener('touchstart', (event) => {
      if (!mobileQuery.matches || event.touches.length !== 1) return;

      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      startScrollLeft = wrapper.scrollLeft;
      isHorizontalSwipe = false;
    }, { passive: true });

    wrapper.addEventListener('touchmove', (event) => {
      if (!mobileQuery.matches || event.touches.length !== 1) return;

      const touch = event.touches[0];
      const moveX = touch.clientX - startX;
      const moveY = touch.clientY - startY;

      if (!isHorizontalSwipe && Math.abs(moveX) > 8) {
        isHorizontalSwipe = Math.abs(moveX) > Math.abs(moveY);
      }

      if (!isHorizontalSwipe) return;

      event.preventDefault();
      wrapper.scrollLeft = startScrollLeft - moveX;
    }, { passive: false, capture: true });
  };

  const prepareFeed = () => {
    unlockInstafeedSwipe();
    document
      .querySelectorAll('.instagram-feed .instagram-feed-wrapper')
      .forEach(enableDragSwipe);
  };

  prepareFeed();

  new MutationObserver(prepareFeed).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
